module.exports = __webpack_public_path__ + "static/media/city3.bade0f80.jpg";